import React, { FC, useEffect } from 'react';
import SeriesDetailHeading from '../SeriesDetail/SeriesDetailHeading';
import { Message } from '../../../shared/components';
import { ExerciseList } from '../SeriesDetail/ExerciseList';
import { useParams } from 'react-router';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { useFetch } from '../../../shared/hooks';
import { getExercisesMapper } from '../../../../config/api/models';
import apiRoutes from '../../../../config/api/routes';
import { GroupStudentSeriesScores } from '../../../../config/api/models/Score';
import { UrlParams } from '../../../shared/types';
import { ExerciseSeriesType } from '../../../../config/api/models/Exercise';

type Props = {
  type: ExerciseSeriesType;
  teacherProgressAndScores?: GroupStudentSeriesScores;
  onExpandedChanged?: () => void;
};

const TrajectoryExercisesEvaluationDetailView: FC<Props> = ({
  type,
  teacherProgressAndScores,
  onExpandedChanged,
}) => {
  const { bookId, chapterId, trajectoryId, sectionCode, sectionName, seriesId } = useParams<
    UrlParams
  >();
  const { getPath } = useI18nPath();
  const [exercisesResponse, getExercises] = useFetch(apiRoutes.blocks(seriesId as string), {
    mapper: getExercisesMapper,
  });

  useEffect(getExercises, [getExercises]);

  return (
    <>
      <SeriesDetailHeading
        seriesId={seriesId as string}
        returnPath={getPath('trajectoryView', {
          bookId: bookId,
          chapterId,
          trajectoryId,
          'sectionCode?': sectionCode,
          'sectionName?': sectionName,
        })}
        mode="read"
      />
      {exercisesResponse.error && <Message type="error">{exercisesResponse.reason}</Message>}
      {exercisesResponse.success && (
        <ExerciseList
          type={type}
          teacherProgressAndScores={teacherProgressAndScores}
          seriesId={seriesId as string}
          exercises={exercisesResponse.data}
          onExpandedChanged={onExpandedChanged}
        />
      )}
    </>
  );
};

export default TrajectoryExercisesEvaluationDetailView;
